export default function upArrow() {
	const uparrow = document.querySelector('.uparrow');

	if (!uparrow) return;

	// Scroll esemény kezelése - megjelenítés/elrejtés
	function toggleVisibility() {
		if (window.scrollY < 200) {
			uparrow.classList.add('d-none');
		} else {
			uparrow.classList.remove('d-none');
		}
	}

	// Smooth scroll az oldal tetejére
	uparrow.addEventListener('click', (e) => {
		e.preventDefault();
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	});

	// Inicializáláskor és scroll eseménykor is ellenőrzés
	window.addEventListener('scroll', toggleVisibility);
	toggleVisibility(); // az oldal betöltésekor is fut
}